<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">Décrivez le type de dommage</div>

    <small
      v-if="
        intervention.typeOfProblem.$invalid && intervention.typeOfProblem.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner un type de problème
    </small>
    <div class="p-d-inline-flex p-jc-between p-my-6" id="impacts-images-container">
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-fissure.png')" alt="Pare-brise" v-on:click="selectTypeOfProblem(1)" />
        <RadioButton
          id="fissure"
          name="typeOfProblem"
          value="1"
          v-model="typeOfProblem"
          class="p-my-3 p-my-sm-3"
        />
        <label for="fissure" class="text-option" v-on:click="selectTypeOfProblem(1)">Fissure</label>
      </div>
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-nombreuximpacts.png')" alt="Pare-brise" v-on:click="selectTypeOfProblem(2)" />
        <RadioButton
          id="impactsNombreux"
          name="typeOfProblem"
          value="2"
          v-model="typeOfProblem"
          class="p-my-3 p-my-sm-3"
        />
        <label for="impactsNombreux" class="text-option" v-on:click="selectTypeOfProblem(2)">Nombreux impacts</label>
      </div>
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-impact.png')" alt="Pare-brise" v-on:click="selectTypeOfProblem(3)" />
        <RadioButton
          id="unImpact"
          name="typeOfProblem"
          value="3"
          v-model="typeOfProblem"
          class="p-my-3 p-my-sm-3"
        />
        <label for="unImpact" class="text-option" v-on:click="selectTypeOfProblem(3)">Un impact</label>
      </div>
    </div>

    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepParebrise",

  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfProblem = ref(null);

    const rules = {
      typeOfProblem: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfProblem,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (typeOfProblem.value) {
        case "1":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.windshield_damage = "windshield_damage";
          appointmentStore.appointment.windshield_reparation = "replace";
          break;
        case "2":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.windshield_damage = "multiple_impact";
          appointmentStore.appointment.windshield_reparation = "replace";
          break;
        case "3":
          nextUrl = "/pare-brise-description";
          appointmentStore.appointment.windshield_damage = "single_impact";
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/pare-brise',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.windshield_damage) dataLayerToPush.windshield_damage = appointmentStore.appointment.windshield_damage;
        if (appointmentStore.appointment.windshield_reparation) dataLayerToPush.windshield_reparation = appointmentStore.appointment.windshield_reparation;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };
    const onPrevious = () => {
      appointmentStore.appointment.windshield_damage = null;
      appointmentStore.appointment.windshield_reparation = null;
      emit("prevPage", menuStore.currentMenuItem);
    };

    const useImage = (imageName) => {
      return require(`../assets/img/${imageName}`);
    };

    const selectTypeOfProblem = (typeOfProblemId) => {
      typeOfProblem.value = `${typeOfProblemId}`
    }

    return {
      onNext,
      intervention,
      typeOfProblem,
      onPrevious,
      useImage,
      selectTypeOfProblem,
    };
  },
  async mounted() {
  },
};
</script>

<style>
.interventionSelectorItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#impacts-images-container {
  width: 60%;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  #impacts-images-container {
    width: 100%;
  }
}
</style>
